// ============================================
// TRADUÇÕES GLOBAIS (root)
// ============================================
import ptCommon from '@/locales/pt.json'
import enCommon from '@/locales/en.json'
import esCommon from '@/locales/es.json'

// ============================================
// TRADUÇÕES - VIEWS
// ============================================
// Português
import ptLogin from '@/locales/pt/views/login.json'
import ptLandingPage from '@/locales/pt/views/landing-page.json'
import ptApp from '@/locales/pt/views/app.json'
import ptExperimentView from '@/locales/pt/views/experimentView.json'
import ptLegalDocumentView from '@/locales/pt/views/legalDocumentView.json'
import ptResetPassword from '@/locales/pt/views/resetPassword.json'
import ptFirstAccess from '@/locales/pt/views/firstAccess.json'
import ptCustomerDetails from '@/locales/pt/views/customerDetails.json'
import ptCompareView from '@/locales/pt/views/compareView.json'
import ptPublicReport from '@/locales/pt/views/publicReport.json'

// English
import enLogin from '@/locales/en/views/login.json'
import enLandingPage from '@/locales/en/views/landing-page.json'
import enApp from '@/locales/en/views/app.json'
import enExperimentView from '@/locales/en/views/experimentView.json'
import enLegalDocumentView from '@/locales/en/views/legalDocumentView.json'
import enResetPassword from '@/locales/en/views/resetPassword.json'
import enFirstAccess from '@/locales/en/views/firstAccess.json'
import enCustomerDetails from '@/locales/en/views/customerDetails.json'
import enCompareView from '@/locales/en/views/compareView.json'
import enPublicReport from '@/locales/en/views/publicReport.json'

// Español
import esLogin from '@/locales/es/views/login.json'
import esLandingPage from '@/locales/es/views/landing-page.json'
import esApp from '@/locales/es/views/app.json'
import esExperimentView from '@/locales/es/views/experimentView.json'
import esLegalDocumentView from '@/locales/es/views/legalDocumentView.json'
import esResetPassword from '@/locales/es/views/resetPassword.json'
import esFirstAccess from '@/locales/es/views/firstAccess.json'
import esCustomerDetails from '@/locales/es/views/customerDetails.json'
import esCompareView from '@/locales/es/views/compareView.json'
import esPublicReport from '@/locales/es/views/publicReport.json'

// ============================================
// TRADUÇÕES - DESIGN SYSTEM
// ============================================
// Português
import ptDsModal from '@/locales/pt/design-system/dsModal.json'
import ptMaintenanceOverlay from '@/locales/pt/design-system/maintenanceOverlay.json'
import ptUploadLimitsCard from '@/locales/pt/design-system/uploadLimitsCard.json'

// English
import enDsModal from '@/locales/en/design-system/dsModal.json'
import enMaintenanceOverlay from '@/locales/en/design-system/maintenanceOverlay.json'
import enUploadLimitsCard from '@/locales/en/design-system/uploadLimitsCard.json'

// Español
import esDsModal from '@/locales/es/design-system/dsModal.json'
import esMaintenanceOverlay from '@/locales/es/design-system/maintenanceOverlay.json'
import esUploadLimitsCard from '@/locales/es/design-system/uploadLimitsCard.json'

// ============================================
// TRADUÇÕES - COMPONENTS/COMMON
// ============================================
// Português
import ptHeader from '@/locales/pt/components/common/header.json'
import ptAppSidebar from '@/locales/pt/components/common/appSidebar.json'
import ptQueueStatus from '@/locales/pt/components/common/queueStatus.json'
import ptProfileSettings from '@/locales/pt/components/common/profileSettings.json'
import ptCommonDialogs from '@/locales/pt/components/common/dialogs.json'
import ptSearchResultsPanel from '@/locales/pt/components/common/searchResultsPanel.json'
import ptAccessibilitySettings from '@/locales/pt/components/common/accessibilitySettings.json'
import ptAccountReports from '@/locales/pt/components/common/accountReports.json'
import ptBulkUploadConfirmation from '@/locales/pt/components/common/bulkUploadConfirmation.json'
import ptCreativeContext from '@/locales/pt/components/common/creativeContext.json'
import ptLayersStep from '@/locales/pt/components/common/layersStep.json'
import ptPrioritiesOnboarding from '@/locales/pt/components/common/prioritiesOnboarding.json'

// English
import enHeader from '@/locales/en/components/common/header.json'
import enAppSidebar from '@/locales/en/components/common/appSidebar.json'
import enQueueStatus from '@/locales/en/components/common/queueStatus.json'
import enProfileSettings from '@/locales/en/components/common/profileSettings.json'
import enCommonDialogs from '@/locales/en/components/common/dialogs.json'
import enSearchResultsPanel from '@/locales/en/components/common/searchResultsPanel.json'
import enAccessibilitySettings from '@/locales/en/components/common/accessibilitySettings.json'
import enAccountReports from '@/locales/en/components/common/accountReports.json'
import enBulkUploadConfirmation from '@/locales/en/components/common/bulkUploadConfirmation.json'
import enCreativeContext from '@/locales/en/components/common/creativeContext.json'
import enLayersStep from '@/locales/en/components/common/layersStep.json'
import enPrioritiesOnboarding from '@/locales/en/components/common/prioritiesOnboarding.json'

// Español
import esHeader from '@/locales/es/components/common/header.json'
import esAppSidebar from '@/locales/es/components/common/appSidebar.json'
import esQueueStatus from '@/locales/es/components/common/queueStatus.json'
import esProfileSettings from '@/locales/es/components/common/profileSettings.json'
import esCommonDialogs from '@/locales/es/components/common/dialogs.json'
import esSearchResultsPanel from '@/locales/es/components/common/searchResultsPanel.json'
import esAccessibilitySettings from '@/locales/es/components/common/accessibilitySettings.json'
import esAccountReports from '@/locales/es/components/common/accountReports.json'
import esBulkUploadConfirmation from '@/locales/es/components/common/bulkUploadConfirmation.json'
import esCreativeContext from '@/locales/es/components/common/creativeContext.json'
import esLayersStep from '@/locales/es/components/common/layersStep.json'
import esPrioritiesOnboarding from '@/locales/es/components/common/prioritiesOnboarding.json'

// ============================================
// TRADUÇÕES - COMPONENTS/FILE_BROWSER
// ============================================
// Português
import ptFileBrowserDialogs from '@/locales/pt/components/file_browser/dialogs.json'
import ptFileBrowserDashboard from '@/locales/pt/components/file_browser/dashboard.json'
import ptTagEditDialog from '@/locales/pt/components/file_browser/tagEditDialog.json'
import ptIntroContent from '@/locales/pt/components/file_browser/introContent.json'
import ptHelpCenter from '@/locales/pt/components/file_browser/helpCenter.json'
import ptFileBrowserGrid from '@/locales/pt/components/file_browser/fileBrowserGrid.json'
import ptEditTagsDialog from '@/locales/pt/components/file_browser/editTagsDialog.json'
import ptFolderTree from '@/locales/pt/components/file_browser/folderTree.json'
import ptMoveItemsDialog from '@/locales/pt/components/file_browser/moveItemsDialog.json'
import ptTagsTree from '@/locales/pt/components/file_browser/tagsTree.json'

// English
import enFileBrowserDialogs from '@/locales/en/components/file_browser/dialogs.json'
import enFileBrowserDashboard from '@/locales/en/components/file_browser/dashboard.json'
import enTagEditDialog from '@/locales/en/components/file_browser/tagEditDialog.json'
import enIntroContent from '@/locales/en/components/file_browser/introContent.json'
import enHelpCenter from '@/locales/en/components/file_browser/helpCenter.json'
import enFileBrowserGrid from '@/locales/en/components/file_browser/fileBrowserGrid.json'
import enEditTagsDialog from '@/locales/en/components/file_browser/editTagsDialog.json'
import enFolderTree from '@/locales/en/components/file_browser/folderTree.json'
import enMoveItemsDialog from '@/locales/en/components/file_browser/moveItemsDialog.json'
import enTagsTree from '@/locales/en/components/file_browser/tagsTree.json'

// Español
import esFileBrowserDialogs from '@/locales/es/components/file_browser/dialogs.json'
import esFileBrowserDashboard from '@/locales/es/components/file_browser/dashboard.json'
import esTagEditDialog from '@/locales/es/components/file_browser/tagEditDialog.json'
import esIntroContent from '@/locales/es/components/file_browser/introContent.json'
import esHelpCenter from '@/locales/es/components/file_browser/helpCenter.json'
import esFileBrowserGrid from '@/locales/es/components/file_browser/fileBrowserGrid.json'
import esEditTagsDialog from '@/locales/es/components/file_browser/editTagsDialog.json'
import esFolderTree from '@/locales/es/components/file_browser/folderTree.json'
import esMoveItemsDialog from '@/locales/es/components/file_browser/moveItemsDialog.json'
import esTagsTree from '@/locales/es/components/file_browser/tagsTree.json'

// ============================================
// TRADUÇÕES - COMPONENTS/MAIN
// ============================================
// Português
import ptMainContentArea from '@/locales/pt/components/main/mainContentArea.json'

// English
import enMainContentArea from '@/locales/en/components/main/mainContentArea.json'

// Español
import esMainContentArea from '@/locales/es/components/main/mainContentArea.json'

// ============================================
// TRADUÇÕES - COMPONENTS/ADMIN
// ============================================
// Português
import ptAdminDialogs from '@/locales/pt/components/admin/dialogs.json'
import ptAccountTypeInfoDialog from '@/locales/pt/components/admin/accountTypeInfoDialog.json'
import ptAccountSituation from '@/locales/pt/components/admin/accountSituation.json'
import ptAccountSubscriptionsPanel from '@/locales/pt/components/admin/accountSubscriptionsPanel.json'
import ptChangePlanDialog from '@/locales/pt/components/admin/changePlanDialog.json'
import ptClientSubscription from '@/locales/pt/components/admin/clientSubscription.json'
import ptLegalDocumentsPanel from '@/locales/pt/components/admin/legalDocumentsPanel.json'
import ptCustomerTimeline from '@/locales/pt/components/admin/customerTimeline.json'
import ptAccountEmailsPanel from '@/locales/pt/components/admin/accountEmailsPanel.json'
import ptAdminDashboard from '@/locales/pt/components/admin/adminDashboard.json'
import ptBillingReportTable from '@/locales/pt/components/admin/billingReportTable.json'
import ptClientBillingInfoPanel from '@/locales/pt/components/admin/clientBillingInfoPanel.json'
import ptCompanyBrandGuidePanel from '@/locales/pt/components/admin/companyBrandGuidePanel.json'
import ptClientEditDialog from '@/locales/pt/components/admin/clientEditDialog.json'
import ptSamlConnectionPanel from '@/locales/pt/components/admin/samlConnectionPanel.json'
import ptClientManagementTable from '@/locales/pt/components/admin/clientManagementTable.json'
import ptFeedbackViewer from '@/locales/pt/components/admin/feedbackViewer.json'
import ptLogViewer from '@/locales/pt/components/admin/logViewer.json'
import ptOnboardingDialog from '@/locales/pt/components/admin/onboardingDialog.json'
import ptPasswordResetDialog from '@/locales/pt/components/admin/passwordResetDialog.json'
import ptPlanEditDialog from '@/locales/pt/components/admin/planEditDialog.json'
import ptPlanManagementTable from '@/locales/pt/components/admin/planManagementTable.json'
import ptSubscriptionEditDialog from '@/locales/pt/components/admin/subscriptionEditDialog.json'
import ptSubscriptionManagementTable from '@/locales/pt/components/admin/subscriptionManagementTable.json'
import ptSubscriptionRequestsTable from '@/locales/pt/components/admin/subscriptionRequestsTable.json'
import ptUserManagementTable from '@/locales/pt/components/admin/userManagementTable.json'
import ptWaitlistViewer from '@/locales/pt/components/admin/waitlistViewer.json'
import ptDashboardHeatmap from '@/locales/pt/components/admin/dashboardHeatmap.json'
import ptUserManagementSection from '@/locales/pt/components/admin/userManagementSection.json'
import ptGrantCreditsDialog from '@/locales/pt/components/admin/grantCreditsDialog.json'
import ptSoftDeletedAccordion from '@/locales/pt/components/admin/softDeletedAccordion.json'
import ptCompanyFolders from '@/locales/pt/components/admin/companyFolders.json'

// English
import enAdminDialogs from '@/locales/en/components/admin/dialogs.json'
import enAccountTypeInfoDialog from '@/locales/en/components/admin/accountTypeInfoDialog.json'
import enAccountSituation from '@/locales/en/components/admin/accountSituation.json'
import enAccountSubscriptionsPanel from '@/locales/en/components/admin/accountSubscriptionsPanel.json'
import enChangePlanDialog from '@/locales/en/components/admin/changePlanDialog.json'
import enClientSubscription from '@/locales/en/components/admin/clientSubscription.json'
import enLegalDocumentsPanel from '@/locales/en/components/admin/legalDocumentsPanel.json'
import enCustomerTimeline from '@/locales/en/components/admin/customerTimeline.json'
import enAccountEmailsPanel from '@/locales/en/components/admin/accountEmailsPanel.json'
import enAdminDashboard from '@/locales/en/components/admin/adminDashboard.json'
import enBillingReportTable from '@/locales/en/components/admin/billingReportTable.json'
import enClientBillingInfoPanel from '@/locales/en/components/admin/clientBillingInfoPanel.json'
import enCompanyBrandGuidePanel from '@/locales/en/components/admin/companyBrandGuidePanel.json'
import enClientEditDialog from '@/locales/en/components/admin/clientEditDialog.json'
import enSamlConnectionPanel from '@/locales/en/components/admin/samlConnectionPanel.json'
import enClientManagementTable from '@/locales/en/components/admin/clientManagementTable.json'
import enFeedbackViewer from '@/locales/en/components/admin/feedbackViewer.json'
import enLogViewer from '@/locales/en/components/admin/logViewer.json'
import enOnboardingDialog from '@/locales/en/components/admin/onboardingDialog.json'
import enPasswordResetDialog from '@/locales/en/components/admin/passwordResetDialog.json'
import enPlanEditDialog from '@/locales/en/components/admin/planEditDialog.json'
import enPlanManagementTable from '@/locales/en/components/admin/planManagementTable.json'
import enSubscriptionEditDialog from '@/locales/en/components/admin/subscriptionEditDialog.json'
import enSubscriptionManagementTable from '@/locales/en/components/admin/subscriptionManagementTable.json'
import enSubscriptionRequestsTable from '@/locales/en/components/admin/subscriptionRequestsTable.json'
import enUserManagementTable from '@/locales/en/components/admin/userManagementTable.json'
import enWaitlistViewer from '@/locales/en/components/admin/waitlistViewer.json'
import enDashboardHeatmap from '@/locales/en/components/admin/dashboardHeatmap.json'
import enUserManagementSection from '@/locales/en/components/admin/userManagementSection.json'
import enGrantCreditsDialog from '@/locales/en/components/admin/grantCreditsDialog.json'
import enSoftDeletedAccordion from '@/locales/en/components/admin/softDeletedAccordion.json'
import enCompanyFolders from '@/locales/en/components/admin/companyFolders.json'

// Español
import esAdminDialogs from '@/locales/es/components/admin/dialogs.json'
import esAccountTypeInfoDialog from '@/locales/es/components/admin/accountTypeInfoDialog.json'
import esAccountSituation from '@/locales/es/components/admin/accountSituation.json'
import esAccountSubscriptionsPanel from '@/locales/es/components/admin/accountSubscriptionsPanel.json'
import esChangePlanDialog from '@/locales/es/components/admin/changePlanDialog.json'
import esClientSubscription from '@/locales/es/components/admin/clientSubscription.json'
import esLegalDocumentsPanel from '@/locales/es/components/admin/legalDocumentsPanel.json'
import esCustomerTimeline from '@/locales/es/components/admin/customerTimeline.json'
import esAccountEmailsPanel from '@/locales/es/components/admin/accountEmailsPanel.json'
import esAdminDashboard from '@/locales/es/components/admin/adminDashboard.json'
import esBillingReportTable from '@/locales/es/components/admin/billingReportTable.json'
import esClientBillingInfoPanel from '@/locales/es/components/admin/clientBillingInfoPanel.json'
import esCompanyBrandGuidePanel from '@/locales/es/components/admin/companyBrandGuidePanel.json'
import esClientEditDialog from '@/locales/es/components/admin/clientEditDialog.json'
import esSamlConnectionPanel from '@/locales/es/components/admin/samlConnectionPanel.json'
import esClientManagementTable from '@/locales/es/components/admin/clientManagementTable.json'
import esFeedbackViewer from '@/locales/es/components/admin/feedbackViewer.json'
import esLogViewer from '@/locales/es/components/admin/logViewer.json'
import esOnboardingDialog from '@/locales/es/components/admin/onboardingDialog.json'
import esPasswordResetDialog from '@/locales/es/components/admin/passwordResetDialog.json'
import esPlanEditDialog from '@/locales/es/components/admin/planEditDialog.json'
import esPlanManagementTable from '@/locales/es/components/admin/planManagementTable.json'
import esSubscriptionEditDialog from '@/locales/es/components/admin/subscriptionEditDialog.json'
import esSubscriptionManagementTable from '@/locales/es/components/admin/subscriptionManagementTable.json'
import esSubscriptionRequestsTable from '@/locales/es/components/admin/subscriptionRequestsTable.json'
import esUserManagementTable from '@/locales/es/components/admin/userManagementTable.json'
import esWaitlistViewer from '@/locales/es/components/admin/waitlistViewer.json'
import esDashboardHeatmap from '@/locales/es/components/admin/dashboardHeatmap.json'
import esUserManagementSection from '@/locales/es/components/admin/userManagementSection.json'
import esGrantCreditsDialog from '@/locales/es/components/admin/grantCreditsDialog.json'
import esSoftDeletedAccordion from '@/locales/es/components/admin/softDeletedAccordion.json'
import esCompanyFolders from '@/locales/es/components/admin/companyFolders.json'

// ============================================
// TRADUÇÕES - COMPONENTS/EXPERIMENT
// ============================================
// Português
import ptAoiPanel from '@/locales/pt/components/experiment/aoiPanel.json'
import ptVideoAOIPanel from '@/locales/pt/components/experiment/videoAOIPanel.json'
import ptAiInsightsPanel from '@/locales/pt/components/experiment/aiInsightsPanel.json'
import ptGazeDistributionCard from '@/locales/pt/components/experiment/gazeDistributionCard.json'
import ptAoiLockedCard from '@/locales/pt/components/experiment/aoiLockedCard.json'
import ptAoiLockedStrip from '@/locales/pt/components/experiment/aoiLockedStrip.json'
import ptGazeLayerCard from '@/locales/pt/components/experiment/gazeLayerCard.json'
import ptIndexRuler from '@/locales/pt/components/experiment/indexRuler.json'
import ptGazeIndexCard from '@/locales/pt/components/experiment/gazeIndexCard.json'
import ptLayersPanel from '@/locales/pt/components/experiment/layersPanel.json'
import ptVideoPlayerWithChart from '@/locales/pt/components/experiment/videoPlayerWithChart.json'
import ptImagePlayerWithAOI from '@/locales/pt/components/experiment/imagePlayerWithAOI.json'
import ptExperimentComparisonView from '@/locales/pt/components/experiment/experimentComparisonView.json'
import ptExperimentStatusOverlay from '@/locales/pt/components/experiment/experimentStatusOverlay.json'
import ptInsightsCarousel from '@/locales/pt/components/experiment/insightsCarousel.json'
import ptInsightsProcessing from '@/locales/pt/components/experiment/insightsProcessing.json'
import ptPdfExportButton from '@/locales/pt/components/experiment/pdfExportButton.json'
import ptPptxReportExport from '@/locales/pt/components/experiment/pptxReportExport.json'
import ptCompareInsights from '@/locales/pt/components/experiment/compareInsights.json'
import ptEngagementComparisonChart from '@/locales/pt/components/experiment/engagementComparisonChart.json'

// English
import enAoiPanel from '@/locales/en/components/experiment/aoiPanel.json'
import enVideoAOIPanel from '@/locales/en/components/experiment/videoAOIPanel.json'
import enAiInsightsPanel from '@/locales/en/components/experiment/aiInsightsPanel.json'
import enGazeDistributionCard from '@/locales/en/components/experiment/gazeDistributionCard.json'
import enAoiLockedCard from '@/locales/en/components/experiment/aoiLockedCard.json'
import enAoiLockedStrip from '@/locales/en/components/experiment/aoiLockedStrip.json'
import enGazeLayerCard from '@/locales/en/components/experiment/gazeLayerCard.json'
import enIndexRuler from '@/locales/en/components/experiment/indexRuler.json'
import enGazeIndexCard from '@/locales/en/components/experiment/gazeIndexCard.json'
import enLayersPanel from '@/locales/en/components/experiment/layersPanel.json'
import enVideoPlayerWithChart from '@/locales/en/components/experiment/videoPlayerWithChart.json'
import enImagePlayerWithAOI from '@/locales/en/components/experiment/imagePlayerWithAOI.json'
import enExperimentComparisonView from '@/locales/en/components/experiment/experimentComparisonView.json'
import enExperimentStatusOverlay from '@/locales/en/components/experiment/experimentStatusOverlay.json'
import enInsightsCarousel from '@/locales/en/components/experiment/insightsCarousel.json'
import enInsightsProcessing from '@/locales/en/components/experiment/insightsProcessing.json'
import enPdfExportButton from '@/locales/en/components/experiment/pdfExportButton.json'
import enPptxReportExport from '@/locales/en/components/experiment/pptxReportExport.json'
import enCompareInsights from '@/locales/en/components/experiment/compareInsights.json'
import enEngagementComparisonChart from '@/locales/en/components/experiment/engagementComparisonChart.json'

// Español
import esAoiPanel from '@/locales/es/components/experiment/aoiPanel.json'
import esVideoAOIPanel from '@/locales/es/components/experiment/videoAOIPanel.json'
import esAiInsightsPanel from '@/locales/es/components/experiment/aiInsightsPanel.json'
import esGazeDistributionCard from '@/locales/es/components/experiment/gazeDistributionCard.json'
import esAoiLockedCard from '@/locales/es/components/experiment/aoiLockedCard.json'
import esAoiLockedStrip from '@/locales/es/components/experiment/aoiLockedStrip.json'
import esGazeLayerCard from '@/locales/es/components/experiment/gazeLayerCard.json'
import esIndexRuler from '@/locales/es/components/experiment/indexRuler.json'
import esGazeIndexCard from '@/locales/es/components/experiment/gazeIndexCard.json'
import esLayersPanel from '@/locales/es/components/experiment/layersPanel.json'
import esVideoPlayerWithChart from '@/locales/es/components/experiment/videoPlayerWithChart.json'
import esImagePlayerWithAOI from '@/locales/es/components/experiment/imagePlayerWithAOI.json'
import esExperimentComparisonView from '@/locales/es/components/experiment/experimentComparisonView.json'
import esExperimentStatusOverlay from '@/locales/es/components/experiment/experimentStatusOverlay.json'
import esInsightsCarousel from '@/locales/es/components/experiment/insightsCarousel.json'
import esInsightsProcessing from '@/locales/es/components/experiment/insightsProcessing.json'
import esPdfExportButton from '@/locales/es/components/experiment/pdfExportButton.json'
import esPptxReportExport from '@/locales/es/components/experiment/pptxReportExport.json'
import esCompareInsights from '@/locales/es/components/experiment/compareInsights.json'
import esEngagementComparisonChart from '@/locales/es/components/experiment/engagementComparisonChart.json'

// ============================================
// TRADUÇÕES - COMPOSABLES
// ============================================
import ptUseMediaUpload from '@/locales/pt/composables/useMediaUpload.json'
import enUseMediaUpload from '@/locales/en/composables/useMediaUpload.json'
import esUseMediaUpload from '@/locales/es/composables/useMediaUpload.json'
import ptUseFileActions from '@/locales/pt/composables/useFileActions.json'
import enUseFileActions from '@/locales/en/composables/useFileActions.json'
import esUseFileActions from '@/locales/es/composables/useFileActions.json'
import ptApiErrorMessage from '@/locales/pt/utils/apiErrorMessage.json'
import enApiErrorMessage from '@/locales/en/utils/apiErrorMessage.json'
import esApiErrorMessage from '@/locales/es/utils/apiErrorMessage.json'
import ptPlanCategory from '@/locales/pt/utils/planCategory.json'
import enPlanCategory from '@/locales/en/utils/planCategory.json'
import esPlanCategory from '@/locales/es/utils/planCategory.json'
import ptUseExperimentData from '@/locales/pt/composables/useExperimentData.json'
import enUseExperimentData from '@/locales/en/composables/useExperimentData.json'
import esUseExperimentData from '@/locales/es/composables/useExperimentData.json'

// ============================================
// OBJETO DE TRADUÇÕES CONSOLIDADO
// ============================================
export const translations = {
  pt: {
    // Root translations (spread first)
    ...ptCommon,

    // Views
    'views.login': ptLogin,
    'views.landing-page': ptLandingPage,
    'views.app': ptApp,
    'views.experimentView': ptExperimentView,
    'views.legalDocumentView': ptLegalDocumentView,
    'views.resetPassword': ptResetPassword,
    'views.firstAccess': ptFirstAccess,
    'views.customerDetails': ptCustomerDetails,
    'views.compareView': ptCompareView,
    'views.publicReport': ptPublicReport,

    // Design System
    'designSystem.dsModal': ptDsModal,
    'designSystem.maintenanceOverlay': ptMaintenanceOverlay,
    'designSystem.uploadLimitsCard': ptUploadLimitsCard,

    // Components - Common
    'components.common.header': ptHeader,
    'components.common.appSidebar': ptAppSidebar,
    'components.common.queueStatus': ptQueueStatus,
    'components.common.profileSettings': ptProfileSettings,
    'components.common.dialogs': ptCommonDialogs,
    'components.common.searchResultsPanel': ptSearchResultsPanel,
    'components.common.accessibilitySettings': ptAccessibilitySettings,
    'components.common.accountReports': ptAccountReports,
    'components.common.bulkUploadConfirmation': ptBulkUploadConfirmation,
    'components.common.creativeContext': ptCreativeContext,
    'components.common.layersStep': ptLayersStep,
    'components.common.prioritiesOnboarding': ptPrioritiesOnboarding,

    // Components - File Browser
    'components.fileBrowser.dialogs': ptFileBrowserDialogs,
    'components.fileBrowser.dashboard': ptFileBrowserDashboard,
    'components.fileBrowser.tagEditDialog': ptTagEditDialog,
    'components.fileBrowser.introContent': ptIntroContent,
    'components.fileBrowser.helpCenter': ptHelpCenter,
    'components.fileBrowser.fileBrowserGrid': ptFileBrowserGrid,
    'components.fileBrowser.editTagsDialog': ptEditTagsDialog,
    'components.fileBrowser.folderTree': ptFolderTree,
    'components.fileBrowser.moveItemsDialog': ptMoveItemsDialog,
    'components.fileBrowser.tagsTree': ptTagsTree,

    // Components - Main
    'components.main.mainContentArea': ptMainContentArea,

    // Components - Admin
    'components.admin.dialogs': ptAdminDialogs,
    'components.admin.accountTypeInfoDialog': ptAccountTypeInfoDialog,
    'components.admin.accountSituation': ptAccountSituation,
    'components.admin.accountSubscriptionsPanel': ptAccountSubscriptionsPanel,
    'components.admin.changePlanDialog': ptChangePlanDialog,
    'components.admin.clientSubscription': ptClientSubscription,
    'components.admin.legalDocumentsPanel': ptLegalDocumentsPanel,
    'components.admin.customerTimeline': ptCustomerTimeline,
    'components.admin.accountEmailsPanel': ptAccountEmailsPanel,
    'components.admin.adminDashboard': ptAdminDashboard,
    'components.admin.billingReportTable': ptBillingReportTable,
    'components.admin.clientBillingInfoPanel': ptClientBillingInfoPanel,
    'components.admin.companyBrandGuidePanel': ptCompanyBrandGuidePanel,
    'components.admin.clientEditDialog': ptClientEditDialog,
    'components.admin.samlConnection': ptSamlConnectionPanel,
    'components.admin.clientManagementTable': ptClientManagementTable,
    'components.admin.feedbackViewer': ptFeedbackViewer,
    'components.admin.logViewer': ptLogViewer,
    'components.admin.onboardingDialog': ptOnboardingDialog,
    'components.admin.passwordResetDialog': ptPasswordResetDialog,
    'components.admin.planEditDialog': ptPlanEditDialog,
    'components.admin.planManagementTable': ptPlanManagementTable,
    'components.admin.subscriptionEditDialog': ptSubscriptionEditDialog,
    'components.admin.subscriptionManagementTable': ptSubscriptionManagementTable,
    'components.admin.subscriptionRequestsTable': ptSubscriptionRequestsTable,
    'components.admin.userManagementTable': ptUserManagementTable,
    'components.admin.waitlistViewer': ptWaitlistViewer,
    'components.admin.dashboardHeatmap': ptDashboardHeatmap,
    'components.admin.userManagementSection': ptUserManagementSection,
    'components.admin.grantCreditsDialog': ptGrantCreditsDialog,
    'components.admin.softDeletedAccordion': ptSoftDeletedAccordion,
    'components.admin.companyFolders': ptCompanyFolders,

    // Components - Experiment
    'components.experiment.aoiPanel': ptAoiPanel,
    'components.experiment.videoAOIPanel': ptVideoAOIPanel,
    'components.experiment.aiInsightsPanel': ptAiInsightsPanel,
    'components.experiment.gazeDistributionCard': ptGazeDistributionCard,
    'components.experiment.aoiLockedCard': ptAoiLockedCard,
    'components.experiment.aoiLockedStrip': ptAoiLockedStrip,
    'components.experiment.gazeLayerCard': ptGazeLayerCard,
    'components.experiment.indexRuler': ptIndexRuler,
    'components.experiment.gazeIndexCard': ptGazeIndexCard,
    'components.experiment.layersPanel': ptLayersPanel,
    'components.experiment.videoPlayerWithChart': ptVideoPlayerWithChart,
    'components.experiment.imagePlayerWithAOI': ptImagePlayerWithAOI,
    'components.experiment.experimentComparisonView': ptExperimentComparisonView,
    'components.experiment.experimentStatusOverlay': ptExperimentStatusOverlay,
    'components.experiment.insightsCarousel': ptInsightsCarousel,
    'components.experiment.insightsProcessing': ptInsightsProcessing,
    'components.experiment.pdfExportButton': ptPdfExportButton,
    'components.experiment.pptxReportExport': ptPptxReportExport,
    'components.experiment.compareInsights': ptCompareInsights,
    'components.experiment.engagementComparisonChart': ptEngagementComparisonChart,

    // Composables
    'composables.useMediaUpload': ptUseMediaUpload,
    'composables.useFileActions': ptUseFileActions,
    'composables.useExperimentData': ptUseExperimentData,
    'utils.apiErrorMessage': ptApiErrorMessage,
    'utils.planCategory': ptPlanCategory,
  },

  en: {
    ...enCommon,

    'views.login': enLogin,
    'views.landing-page': enLandingPage,
    'views.app': enApp,
    'views.experimentView': enExperimentView,
    'views.legalDocumentView': enLegalDocumentView,
    'views.resetPassword': enResetPassword,
    'views.firstAccess': enFirstAccess,
    'views.customerDetails': enCustomerDetails,
    'views.compareView': enCompareView,
    'views.publicReport': enPublicReport,

    'designSystem.dsModal': enDsModal,
    'designSystem.maintenanceOverlay': enMaintenanceOverlay,
    'designSystem.uploadLimitsCard': enUploadLimitsCard,

    'components.common.header': enHeader,
    'components.common.appSidebar': enAppSidebar,
    'components.common.queueStatus': enQueueStatus,
    'components.common.profileSettings': enProfileSettings,
    'components.common.dialogs': enCommonDialogs,
    'components.common.searchResultsPanel': enSearchResultsPanel,
    'components.common.accessibilitySettings': enAccessibilitySettings,
    'components.common.accountReports': enAccountReports,
    'components.common.bulkUploadConfirmation': enBulkUploadConfirmation,
    'components.common.creativeContext': enCreativeContext,
    'components.common.layersStep': enLayersStep,
    'components.common.prioritiesOnboarding': enPrioritiesOnboarding,

    'components.fileBrowser.dialogs': enFileBrowserDialogs,
    'components.fileBrowser.dashboard': enFileBrowserDashboard,
    'components.fileBrowser.tagEditDialog': enTagEditDialog,
    'components.fileBrowser.introContent': enIntroContent,
    'components.fileBrowser.helpCenter': enHelpCenter,
    'components.fileBrowser.fileBrowserGrid': enFileBrowserGrid,
    'components.fileBrowser.editTagsDialog': enEditTagsDialog,
    'components.fileBrowser.folderTree': enFolderTree,
    'components.fileBrowser.moveItemsDialog': enMoveItemsDialog,
    'components.fileBrowser.tagsTree': enTagsTree,

    // Components - Main
    'components.main.mainContentArea': enMainContentArea,

    'components.admin.dialogs': enAdminDialogs,
    'components.admin.accountTypeInfoDialog': enAccountTypeInfoDialog,
    'components.admin.accountSituation': enAccountSituation,
    'components.admin.accountSubscriptionsPanel': enAccountSubscriptionsPanel,
    'components.admin.changePlanDialog': enChangePlanDialog,
    'components.admin.clientSubscription': enClientSubscription,
    'components.admin.legalDocumentsPanel': enLegalDocumentsPanel,
    'components.admin.customerTimeline': enCustomerTimeline,
    'components.admin.accountEmailsPanel': enAccountEmailsPanel,
    'components.admin.adminDashboard': enAdminDashboard,
    'components.admin.billingReportTable': enBillingReportTable,
    'components.admin.clientBillingInfoPanel': enClientBillingInfoPanel,
    'components.admin.companyBrandGuidePanel': enCompanyBrandGuidePanel,
    'components.admin.clientEditDialog': enClientEditDialog,
    'components.admin.samlConnection': enSamlConnectionPanel,
    'components.admin.clientManagementTable': enClientManagementTable,
    'components.admin.feedbackViewer': enFeedbackViewer,
    'components.admin.logViewer': enLogViewer,
    'components.admin.onboardingDialog': enOnboardingDialog,
    'components.admin.passwordResetDialog': enPasswordResetDialog,
    'components.admin.planEditDialog': enPlanEditDialog,
    'components.admin.planManagementTable': enPlanManagementTable,
    'components.admin.subscriptionEditDialog': enSubscriptionEditDialog,
    'components.admin.subscriptionManagementTable': enSubscriptionManagementTable,
    'components.admin.subscriptionRequestsTable': enSubscriptionRequestsTable,
    'components.admin.userManagementTable': enUserManagementTable,
    'components.admin.waitlistViewer': enWaitlistViewer,
    'components.admin.dashboardHeatmap': enDashboardHeatmap,
    'components.admin.userManagementSection': enUserManagementSection,
    'components.admin.grantCreditsDialog': enGrantCreditsDialog,
    'components.admin.softDeletedAccordion': enSoftDeletedAccordion,
    'components.admin.companyFolders': enCompanyFolders,

    // Components - Experiment
    'components.experiment.aoiPanel': enAoiPanel,
    'components.experiment.videoAOIPanel': enVideoAOIPanel,
    'components.experiment.aiInsightsPanel': enAiInsightsPanel,
    'components.experiment.gazeDistributionCard': enGazeDistributionCard,
    'components.experiment.aoiLockedCard': enAoiLockedCard,
    'components.experiment.aoiLockedStrip': enAoiLockedStrip,
    'components.experiment.gazeLayerCard': enGazeLayerCard,
    'components.experiment.indexRuler': enIndexRuler,
    'components.experiment.gazeIndexCard': enGazeIndexCard,
    'components.experiment.layersPanel': enLayersPanel,
    'components.experiment.videoPlayerWithChart': enVideoPlayerWithChart,
    'components.experiment.imagePlayerWithAOI': enImagePlayerWithAOI,
    'components.experiment.experimentComparisonView': enExperimentComparisonView,
    'components.experiment.experimentStatusOverlay': enExperimentStatusOverlay,
    'components.experiment.insightsCarousel': enInsightsCarousel,
    'components.experiment.insightsProcessing': enInsightsProcessing,
    'components.experiment.pdfExportButton': enPdfExportButton,
    'components.experiment.pptxReportExport': enPptxReportExport,
    'components.experiment.compareInsights': enCompareInsights,
    'components.experiment.engagementComparisonChart': enEngagementComparisonChart,

    // Composables
    'composables.useMediaUpload': enUseMediaUpload,
    'composables.useFileActions': enUseFileActions,
    'composables.useExperimentData': enUseExperimentData,
    'utils.apiErrorMessage': enApiErrorMessage,
    'utils.planCategory': enPlanCategory,
  },

  es: {
    ...esCommon,

    'views.login': esLogin,
    'views.landing-page': esLandingPage,
    'views.app': esApp,
    'views.experimentView': esExperimentView,
    'views.legalDocumentView': esLegalDocumentView,
    'views.resetPassword': esResetPassword,
    'views.firstAccess': esFirstAccess,
    'views.customerDetails': esCustomerDetails,
    'views.compareView': esCompareView,
    'views.publicReport': esPublicReport,

    'designSystem.dsModal': esDsModal,
    'designSystem.maintenanceOverlay': esMaintenanceOverlay,
    'designSystem.uploadLimitsCard': esUploadLimitsCard,

    'components.common.header': esHeader,
    'components.common.appSidebar': esAppSidebar,
    'components.common.queueStatus': esQueueStatus,
    'components.common.profileSettings': esProfileSettings,
    'components.common.dialogs': esCommonDialogs,
    'components.common.searchResultsPanel': esSearchResultsPanel,
    'components.common.accessibilitySettings': esAccessibilitySettings,
    'components.common.accountReports': esAccountReports,
    'components.common.bulkUploadConfirmation': esBulkUploadConfirmation,
    'components.common.creativeContext': esCreativeContext,
    'components.common.layersStep': esLayersStep,
    'components.common.prioritiesOnboarding': esPrioritiesOnboarding,

    'components.fileBrowser.dialogs': esFileBrowserDialogs,
    'components.fileBrowser.dashboard': esFileBrowserDashboard,
    'components.fileBrowser.tagEditDialog': esTagEditDialog,
    'components.fileBrowser.introContent': esIntroContent,
    'components.fileBrowser.helpCenter': esHelpCenter,
    'components.fileBrowser.fileBrowserGrid': esFileBrowserGrid,
    'components.fileBrowser.editTagsDialog': esEditTagsDialog,
    'components.fileBrowser.folderTree': esFolderTree,
    'components.fileBrowser.moveItemsDialog': esMoveItemsDialog,
    'components.fileBrowser.tagsTree': esTagsTree,

    // Components - Main
    'components.main.mainContentArea': esMainContentArea,

    'components.admin.dialogs': esAdminDialogs,
    'components.admin.accountTypeInfoDialog': esAccountTypeInfoDialog,
    'components.admin.accountSituation': esAccountSituation,
    'components.admin.accountSubscriptionsPanel': esAccountSubscriptionsPanel,
    'components.admin.changePlanDialog': esChangePlanDialog,
    'components.admin.clientSubscription': esClientSubscription,
    'components.admin.legalDocumentsPanel': esLegalDocumentsPanel,
    'components.admin.customerTimeline': esCustomerTimeline,
    'components.admin.accountEmailsPanel': esAccountEmailsPanel,
    'components.admin.adminDashboard': esAdminDashboard,
    'components.admin.billingReportTable': esBillingReportTable,
    'components.admin.clientBillingInfoPanel': esClientBillingInfoPanel,
    'components.admin.companyBrandGuidePanel': esCompanyBrandGuidePanel,
    'components.admin.clientEditDialog': esClientEditDialog,
    'components.admin.samlConnection': esSamlConnectionPanel,
    'components.admin.clientManagementTable': esClientManagementTable,
    'components.admin.feedbackViewer': esFeedbackViewer,
    'components.admin.logViewer': esLogViewer,
    'components.admin.onboardingDialog': esOnboardingDialog,
    'components.admin.passwordResetDialog': esPasswordResetDialog,
    'components.admin.planEditDialog': esPlanEditDialog,
    'components.admin.planManagementTable': esPlanManagementTable,
    'components.admin.subscriptionEditDialog': esSubscriptionEditDialog,
    'components.admin.subscriptionManagementTable': esSubscriptionManagementTable,
    'components.admin.subscriptionRequestsTable': esSubscriptionRequestsTable,
    'components.admin.userManagementTable': esUserManagementTable,
    'components.admin.waitlistViewer': esWaitlistViewer,
    'components.admin.dashboardHeatmap': esDashboardHeatmap,
    'components.admin.userManagementSection': esUserManagementSection,
    'components.admin.grantCreditsDialog': esGrantCreditsDialog,
    'components.admin.softDeletedAccordion': esSoftDeletedAccordion,
    'components.admin.companyFolders': esCompanyFolders,

    // Components - Experiment
    'components.experiment.aoiPanel': esAoiPanel,
    'components.experiment.videoAOIPanel': esVideoAOIPanel,
    'components.experiment.aiInsightsPanel': esAiInsightsPanel,
    'components.experiment.gazeDistributionCard': esGazeDistributionCard,
    'components.experiment.aoiLockedCard': esAoiLockedCard,
    'components.experiment.aoiLockedStrip': esAoiLockedStrip,
    'components.experiment.gazeLayerCard': esGazeLayerCard,
    'components.experiment.indexRuler': esIndexRuler,
    'components.experiment.gazeIndexCard': esGazeIndexCard,
    'components.experiment.layersPanel': esLayersPanel,
    'components.experiment.videoPlayerWithChart': esVideoPlayerWithChart,
    'components.experiment.imagePlayerWithAOI': esImagePlayerWithAOI,
    'components.experiment.experimentComparisonView': esExperimentComparisonView,
    'components.experiment.experimentStatusOverlay': esExperimentStatusOverlay,
    'components.experiment.insightsCarousel': esInsightsCarousel,
    'components.experiment.insightsProcessing': esInsightsProcessing,
    'components.experiment.pdfExportButton': esPdfExportButton,
    'components.experiment.pptxReportExport': esPptxReportExport,
    'components.experiment.compareInsights': esCompareInsights,
    'components.experiment.engagementComparisonChart': esEngagementComparisonChart,

    // Composables
    'composables.useMediaUpload': esUseMediaUpload,
    'composables.useFileActions': esUseFileActions,
    'composables.useExperimentData': esUseExperimentData,
    'utils.apiErrorMessage': esApiErrorMessage,
    'utils.planCategory': esPlanCategory,
  }
}
